"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var MapProcessingUtil = _interopRequireWildcard(require("../MapProcessingUtil"));
var config = _interopRequireWildcard(require("../MapProcessing/config"));
var _LocationType = _interopRequireDefault(require("./LocationType"));
var _misc = _interopRequireDefault(require("./misc"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
const _validateOtherGpsReadingData = gpsReadingOtherProps => {
  const {
    // This is data actually consumed
    // nextAzimuth,
    // nextDistance,
    // This is data we might expect to be here, but we are not using these
    nextGap,
    prevGap,
    prevAzimuth,
    prevDistance,
    // This is unexpected data
    ...otherProps
  } = gpsReadingOtherProps;
  _misc.default.validateEmptyProps('gpsreading', otherProps);
};
const _validateReadingsData = readingOtherProps => {
  _misc.default.validateEmptyProps('reading', readingOtherProps);
};
const _validateReadingsValueData = readingsValueOtherProps => {
  _misc.default.validateEmptyProps('reading.value', readingsValueOtherProps);
};

// Adds other items (like elevation and pdop) to new coordinates when necessary
const _extendInterpolatedCoordinates = (originalCoordinates, newCoordinates) => {
  originalCoordinates.forEach((originalCoord, i) => {
    if (newCoordinates[i] !== undefined) {
      return;
    }
    newCoordinates[i] = originalCoord;
  });
};

// TODO: We should only try to pull DCVG data if surveyType=DCVG
const flattenGpsReadings = function (originalGpsReadings) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const [{
    code,
    locationType
  } = {}] = originalGpsReadings;

  // Checks to see if already flattened
  if (code !== undefined || locationType !== undefined) {
    return originalGpsReadings;
  }
  const {
    algorithm = config.GEO_ALGORITHMS.GEOD
  } = options;
  const flattenedReadings = [];
  const filteredGPSReadings = originalGpsReadings.filter(_ref => {
    let {
      coordinates = [0, 0]
    } = _ref;
    return coordinates.length !== 0;
  });
  filteredGPSReadings.forEach((gpsReading, n) => {
    const {
      readings,
      coordinates: originalCoordinates,
      // TODO: These are metadata describing how close readings are from each other - consider not saving these
      // There should not be any additional props
      nextDistance,
      nextAzimuth,
      ...otherProps
    } = gpsReading;
    _validateOtherGpsReadingData(otherProps);
    const isLastItem = n === filteredGPSReadings.length - 1;
    const isSecondLastItem = n === filteredGPSReadings.length - 2;
    readings.forEach((reading, i) => {
      const {
        value,
        code,
        ...otherReadingProps
      } = reading;
      _validateReadingsData(otherReadingProps);
      const {
        StationId,
        comments,
        time,
        oldStns,
        readingReplaced,
        // ON-OFF
        reading1,
        reading2,
        originalReading1,
        originalReading2,
        // DCVG
        ir,
        doc,
        ss,
        flaggedSS,
        flaggedStn,
        olre,
        clock,
        interpolatedReading1,
        interpolatedReading2,
        acOn,
        acOff,
        gpsType,
        triggerType,
        docTop,
        fileName,
        originalComments,
        ...otherReadingValueProps
      } = value;
      _validateReadingsValueData(otherReadingValueProps);

      // combination of "reading" and "reading.value"
      const readingShell = {
        code,
        StationId,
        comments,
        oldStns,
        time,
        // ON-OFF
        reading1,
        reading2,
        originalReading1,
        originalReading2,
        // DCVG
        ir,
        doc,
        ss,
        flaggedSS,
        flaggedStn,
        olre,
        clock,
        interpolatedReading1,
        interpolatedReading2,
        acOn,
        acOff,
        gpsType,
        triggerType,
        docTop,
        fileName,
        originalComments
      };
      _misc.default.cleanEmptyValues(readingShell);

      // TODO: We don't want to interpolate readings if they are in the last gps reading

      if (i === 0) {
        // We don't need to interpolate this as there is just the one item
        const newGpsReading = {
          ...readingShell,
          locationType: _LocationType.default.GPS,
          coordinates: originalCoordinates
        };
        flattenedReadings.push(newGpsReading);
        return;
      }
      let coords;
      if (isLastItem) {
        coords = originalCoordinates;
      } else {
        coords = MapProcessingUtil.calculateInterpolatedPosition(gpsReading.coordinates[1], gpsReading.coordinates[0], nextDistance === undefined ? 0 : nextDistance, nextAzimuth, i, readings.length, {
          algorithm
        });
      }
      _extendInterpolatedCoordinates(originalCoordinates, coords);
      if (isSecondLastItem) {
        const {
          coordinates: lastCoordinates
        } = filteredGPSReadings[filteredGPSReadings.length - 1];
        if (lastCoordinates.length === 5 && lastCoordinates[4] === true) {
          coords.splice(4, 0, true);
        }
      }
      const interpolatedGpsReading = {
        ...readingShell,
        locationType: _LocationType.default.INTERPOLATED,
        coordinates: coords
      };
      flattenedReadings.push(interpolatedGpsReading);
    });
  });
  MapProcessingUtil.updateGPSMeasurements(flattenedReadings);
  return flattenedReadings;
};
var _default = flattenGpsReadings;
exports.default = _default;